// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"c3fc5c63","138":"bf7f0e85","155":"0979a5c3","314":"2640ff17","347":"58418b57","453":"670e15c7","457":"eb2011ff","583":"080363b5","615":"1b23bb81","760":"ec4e6534","841":"5ee523e2"}[chunkId] + ".chunk.js";
};